import React from 'react';
import PropTypes from 'prop-types';

import createXssFilter from '../../../store/createXssFilter';

const xssFilter = createXssFilter();

const ErrorMessage = (props) => {
  return (
    <div
      className="accommodation-reservation-form__error-message"
      dangerouslySetInnerHTML={{ __html: xssFilter(props.message) }}
    ></div>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorMessage;
